module.exports = __webpack_public_path__ + "img/performance-work-icon3.17e967bf.png";